var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFullBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5V1c0-.55-.4-1-.89-1H.89C.4 0 0 .45 0 1v4c0 .55.4 1 .89 1v9C.4 15 0 15.45 0 16v2c0 .55.4 1 .89 1h.89c0 .55.4 1 .89 1s.89-.45.89-1h9.84c0 .55.4 1 .89 1s.89-.45.89-1h.89c.53 0 .93-.45.93-1v-2c0-.55-.4-1-.89-1V6c.49 0 .89-.45.89-1zm-.89 11.25v1.5c0 .14-.1.25-.22.25H1.12C1 18 .9 17.89.9 17.75v-1.5c0-.14.1-.25.22-.25h14.76c.13 0 .23.11.23.25zM8.05 8h6.26c.49 0 .89.45.89 1v6H1.79V9c0-.55.4-1 .89-1h5.37zM2.68 5.5v-2c0-.28.2-.5.45-.5H7.6c.25 0 .45.22.45.5v2c0 .28-.2.5-.45.5H3.13c-.25 0-.45-.22-.45-.5zm6.27 0v-2c0-.28.2-.5.45-.5h4.47c.25 0 .45.22.45.5v2c0 .28-.2.5-.45.5H9.39c-.24 0-.44-.22-.44-.5zm6.71-.5h-.45V3c0-.55-.4-1-.89-1H2.68c-.49 0-.89.45-.89 1v2h-.45c-.24 0-.45-.22-.45-.5v-3c0-.28.15-.5.33-.5h14.57c.18 0 .32.22.32.5v3c0 .28-.21.5-.45.5z",
    fill: "#1ab2c5"
  })));
}

export default SvgIconFullBed;